import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import RadioButtonGroup from '../../components/_molecules/RadioButtonGroup/RadioButtonGroup';
import { getFieldInitialState } from '../../utils/helpers';
import {
  TEXT_FIELD_STATUS,
  INIT,
  LOADING,
  SUCCESS,
  ERROR,
  publicHash,
  // PROFILE_STEP_STATUSES,
} from '../../utils/constants';
import StripeCard from '../../components/StripeCard/StripeCard';
import InvoiceForm from '../../components/InvoiceForm/InvoiceForm';
import './AddPayment.scss';
import LoadingOverlay from '../../components/_molecules/LoadingOverlay/LoadingOverlay';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';

const paymentSelectRadioName = 'payment-select';

class AddPayment extends Component {
  static propTypes = {
    updateCard: PropTypes.func.isRequired,
    updateCardStatus: PropTypes.string.isRequired,
    updateInvoice: PropTypes.func.isRequired,
    updateInvoiceStatus: PropTypes.string.isRequired,
    updateInvoiceError: PropTypes.string.isRequired,
    updateCardError: PropTypes.string.isRequired,
    annulStoreErrors: PropTypes.func.isRequired,
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
    // profileStepStatus: PropTypes.string.isRequired,
    userStatus: PropTypes.string.isRequired,
    getProfileStatus: PropTypes.func.isRequired,
    isFirstFlow: PropTypes.bool.isRequired,
    deleteCard: PropTypes.func.isRequired,
    deleteCardStatus: PropTypes.string.isRequired,
    invoiceMethod: PropTypes.shape({}).isRequired,
    deleteInvoiceStatus: PropTypes.string.isRequired,
    deleteInvoice: PropTypes.func.isRequired,
    cardMethod: PropTypes.shape({}).isRequired,
    getProfile: PropTypes.func.isRequired,
    location: PropTypes.shape({}).isRequired,
  };

  constructor() {
    super();
    this.fields = {};
  }

  state = {
    fields: {
      [paymentSelectRadioName]: getFieldInitialState(
        undefined,
        undefined,
        'card',
      ),
    },
    stripeState: INIT,
    token: '',
  };

  componentDidMount() {
    const { isFirstFlow } = this.props;
    if (isFirstFlow) {
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = () => {
        window.history.go(1);
      };
    }
  }

  componentDidUpdate(prevProps) {
    const {
      updateCardStatus,
      updateInvoiceStatus,
      history: { push },
      getProfileStatus,
      deleteInvoiceStatus,
      updateCard,
      getProfile,
      userStatus,
      isFirstFlow,
      location: { pathname },
    } = this.props;
    if
    (updateInvoiceStatus !== prevProps.updateInvoiceStatus &&
        updateInvoiceStatus === SUCCESS) {
      getProfile();
      getProfileStatus();
    }
    if ((updateCardStatus !== prevProps.updateCardStatus &&
      updateCardStatus === SUCCESS)) {
      getProfile();
    }
    if (
      userStatus !== prevProps.userStatus &&
     userStatus === SUCCESS
    ) {
      if (updateCardStatus === SUCCESS) {
        push(`${publicHash}/app/refill`);
      }
    }
    if (prevProps.deleteInvoiceStatus !== deleteInvoiceStatus && deleteInvoiceStatus === SUCCESS) {
      const { token } = this.state;
      updateCard({ token });
      this.setState(() => ({ stripeState: SUCCESS }));
    }
    if (prevProps.userStatus !== userStatus && pathname.indexOf('update-payment') > -1 && !isFirstFlow) {
      push(`${publicHash}/app/my-money`);
    }
  }

  componentWillUnmount() {
    window.onpopstate = undefined;
  }

  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };
    fields[name].value = value;
    if (
      fields[name].status !== TEXT_FIELD_STATUS.INITIAL &&
      !fields[name].outerError
    ) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
    }
    this.setState(() => ({ fields }));
  };

  stripeLoadingHandler = () => {
    this.setState(() => ({ stripeState: LOADING }));
  };

  stripeSuccessHandler = (token) => {
    // do stripe delete invoice logic at top level
    // to do less changes at stripe form for more
    const { updateCard, invoiceMethod, deleteInvoice } = this.props;
    if (token.id) {
      if (!invoiceMethod.active) {
        updateCard({ token: token.id });
        this.setState(() => ({ stripeState: SUCCESS }));
      } else {
        this.setState(() => ({
          token: token.id,
        }), () => {
          deleteInvoice();
        });
      }
    }
  };
  // Stripe thinks that it's unreachable, but let it be, at least console :)
  stripeErrorHandler = () => {
    // console.log(e, 'error');
  };

  render() {
    const { fields, stripeState } = this.state;
    const {
      updateInvoice,
      updateInvoiceStatus,
      updateCardStatus,
      updateCardError,
      updateInvoiceError,
      annulStoreErrors,
      userStatus,
      deleteCard,
      invoiceMethod,
      deleteCardStatus,
      // deleteInvoiceStatus,
      cardMethod,
    } = this.props;
    const paymentSelectRadio = fields[paymentSelectRadioName];
    const addPaymentClassNames = classNames({
      screen: true,
      'add-payment-screen': true,
      'is-card': paymentSelectRadio.value === 'card',
      'is-invoice': paymentSelectRadio.value === 'invoice',
    });

    const isLoading =
      stripeState === LOADING ||
      updateCardStatus === LOADING ||
      updateInvoiceStatus === LOADING ||
      userStatus === LOADING || deleteCardStatus === LOADING;
    const isError = updateCardStatus === ERROR;
    const errorText = updateCardError || updateInvoiceError;
    return (
      <div className={addPaymentClassNames}>
        <LoadingOverlay visible={isLoading} />
        <ErrorModal
          visible={isError}
          error={errorText}
          requestClose={annulStoreErrors}
        />
        <div className="add-payment-content">

          { (!cardMethod.active && !invoiceMethod.active) ?
            <div className="main-label">Add Payment Method</div> :
            <div className="main-label">Update Payment Method</div> }

          <div className="payment-select">
            <RadioButtonGroup
              changeHandler={this.fieldChangeHandler}
              status={paymentSelectRadio.status}
              errorText={paymentSelectRadio.errorText}
              registerField={this.registerField}
              name={paymentSelectRadioName}
              value={paymentSelectRadio.value}
              values={['card', 'invoice']}
            >
              <div className="option-wrapper">
                <span>Credit Card</span>
              </div>
              <div className="option-wrapper">
                <span>Invoice</span>
              </div>
            </RadioButtonGroup>
          </div>

          <div className="payments-wrapper">
            <div className="payments-inner">
              <StripeCard
                onSuccess={this.stripeSuccessHandler}
                onError={this.stripeErrorHandler}
                onLoad={this.stripeLoadingHandler}

              />
              <InvoiceForm
                submitHandler={updateInvoice}
                deleteCard={deleteCard}
                invoiceMethod={invoiceMethod}
                cardMethod={cardMethod}
                deleteCardStatus={deleteCardStatus}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddPayment;



// WEBPACK FOOTER //
// ./src/containers/AddPayment/AddPayment.js